import { Checkbox } from "@mui/material";
import type { ReactElement } from "react";

/**
 * Checkbox cell with indeterminate support and a stop-propagation
 * onClick (so a click inside a `<tr onClick>` row never double-fires).
 *
 * The `onToggle` callback receives a `{ shiftKey }` flag — wire it
 * straight into `useBulkSelection().toggle` to get range-select for
 * free.
 */
export function BulkCheckbox({
  checked,
  indeterminate,
  onChange,
  ariaLabel,
}: {
  checked: boolean;
  indeterminate?: boolean;
  onChange: (
    nextChecked: boolean,
    opts: { shiftKey: boolean },
  ) => void;
  ariaLabel: string;
}): ReactElement {
  return (
    <Checkbox
      size="small"
      checked={checked}
      indeterminate={!!indeterminate && !checked}
      inputProps={{ "aria-label": ariaLabel }}
      onClick={(e) => e.stopPropagation()}
      onChange={(e) =>
        onChange(e.target.checked, {
          // The checkbox's onChange event surfaces the original click's
          // shiftKey. Browsers preserve it through the synthetic
          // wrapper React provides.
          shiftKey: (e.nativeEvent as MouseEvent).shiftKey === true,
        })
      }
      sx={{ p: 0.5, cursor: "pointer" }}
    />
  );
}
